var map = {
	"./3hearts.png": "7f99",
	"./airplane-icon.svg": "9402",
	"./awesome.svg": "0215",
	"./back-arrow.svg": "9e57",
	"./demo.svg": "3f64",
	"./demo/dotted-point-arrow.svg": "e5c8",
	"./demo/frame.png": "30a1",
	"./demo/mojito.png": "7dfd",
	"./demo/salad.png": "22d2",
	"./demo/siverware.png": "ad00",
	"./demo/try-it-now.svg": "68fa",
	"./error-icon.svg": "9b4c",
	"./eye-icon.svg": "4c0b",
	"./file-icon.svg": "c566",
	"./gray-outline-heart.svg": "3fab",
	"./icon-QR.svg": "1d47",
	"./icon-email.svg": "19d0",
	"./icon-phone.svg": "6ab6",
	"./icon-silverware.svg": "8b80",
	"./icon-twitter.svg": "5cfb",
	"./icon-youtube.svg": "63ec",
	"./iphone-white.png": "0db9",
	"./loading-spinner.svg": "616b",
	"./logo-menus.svg": "1e69",
	"./notepad-icon.svg": "8d5f",
	"./shadow-heart.png": "927b",
	"./smart-move.svg": "a896",
	"./success-icon.svg": "d105",
	"./tailwind.css": "ba8c",
	"./trash-icon.svg": "19ff",
	"./wand-icon.svg": "97f8",
	"./white-fill-heart.svg": "cd3d",
	"./white-x.svg": "b055"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";